import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'styled-components';
import { getLegalLink } from '../legal/getLegalLink';
import { usePrivacyBanner } from './usePrivacyBanner';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPolicyLink = styled.span.withConfig({
  displayName: "PrivacyPolicy__StyledPolicyLink",
  componentId: "w0mlzm-0"
})(({
  theme
}) => {
  return {
    color: theme.color['text-core-subtle'],
    textDecoration: 'underline',
    fontFamily: theme.typography['body-125'].fontFamily,
    fontWeight: theme.typography['body-100'].fontWeight,
    fontSize: theme.typography['detail-200'].fontSize,
    lineHeight: theme.typography['detail-200'].lineHeight,
    fontLetterSpacing: theme.typography['detail-200'].letterSpacing,
    WebkitFontSmoothing: 'auto',
    MozOsxFontSmoothing: 'auto'
  };
});
const PrivacyPolicy = () => {
  const {
    handleClickPrivacyPolicy,
    shouldShowPrivacyBanner
  } = usePrivacyBanner();
  if (!shouldShowPrivacyBanner) {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    color: "text-core-subtle",
    typography: "detail-200",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'legal.gdpr-text-sidepanel',
      options: {
        privacyPolicyLink: /*#__PURE__*/_jsx(Link, {
          external: true,
          hideExternalLinkIcon: true,
          href: getLegalLink('privacy-policy'),
          onClick: handleClickPrivacyPolicy,
          children: /*#__PURE__*/_jsx(StyledPolicyLink, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "legal.privacyPolicyLink"
            })
          })
        })
      }
    })
  });
};
export default PrivacyPolicy;